import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.pin-reset', {
        url: '/pin_reset',
        component: 'pinReset',
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/public/pin-reset/pin-reset.state.js